"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mouseMode = _interopRequireDefault(require("./1-mouseMode"));

var _keyboardMode = _interopRequireDefault(require("./2-keyboardMode"));

var _targetSelection = _interopRequireDefault(require("./3-targetSelection"));

var _skillRegistration = _interopRequireDefault(require("./4-skillRegistration"));

var _movingAndTrading = _interopRequireDefault(require("./5-movingAndTrading"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var input = {
  id: "input",
  title: {
    en: "Input",
    de: "Eingabe"
  },
  chapters: [_mouseMode.default, _keyboardMode.default, _targetSelection.default, _skillRegistration.default, _movingAndTrading.default]
};
var _default = input;
exports.default = _default;